import { useEffect } from 'react';

const useHeadlessDetection = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;

    const isHeadless = () => {
      const hasWebdriver = navigator.webdriver;
      const userAgent = navigator.userAgent.toLowerCase();
      const isHeadlessUA = userAgent.includes('headless') || userAgent.includes('phantom');

      return hasWebdriver || isHeadlessUA;
    };

    if (isHeadless()) {
      alert("Headless browser detected. Access denied.");
      window.location.href = "/bot-detected.html";
    }
  }, []);
};

export default useHeadlessDetection;
